import React from 'react';
import { labels } from '../data/labels';
import { useExpandedView, useExpandedViewDispatch } from './ExpandedViewProvider';

export default function ExpandedViewToggle() {
    const expandedView = useExpandedView();
    const dispatch = useExpandedViewDispatch();

    return (
        <div className="d-flex push-right">
            <label className="custom-switch-2 mr-2">
                <input type="checkbox" checked={expandedView.toggled} onChange={() => dispatch({action: 'toggle'})} />
                <span className="custom-slider-2 round"></span>
            </label>
            <span>{labels['general.expanded_view']}</span>
        </div>
    );
}
